import { Button, Table, OverlayTrigger, Popover } from 'react-bootstrap'
import { Link } from 'react-router-dom'
import { Trash2, SquarePen } from 'lucide-react'
import moment from 'moment'
import { tableHeaderStyle } from './constants'

const PickupCommandTable = ({
  pickupCommand,
  detail,
  routeValue,
  setShowModalAddUpdateItem,
  setEditData,
  handleCreateWorkOrder,
  handleDeleteAddItemPickupCommand
}) => {
  return (
    <Table hover responsive style={{ fontSize: '12px' }}>
      <thead style={{ backgroundColor: '#f8f9fa' }}>
        <tr>
          <th className="p-2 align-middle" style={tableHeaderStyle}>
            No
          </th>
          <th
            className="p-2 align-middle"
            style={{
              ...tableHeaderStyle,
              width: '30%'
            }}
          >
            Item Code - Name
          </th>
          <th className="p-2 text-end align-middle" style={tableHeaderStyle}>
            Item Alias
          </th>
          <th className="p-2 text-end align-middle" style={tableHeaderStyle}>
            Batch
          </th>
          <th className="p-2 text-end align-middle" style={tableHeaderStyle}>
            Expired
          </th>
          <th className="p-2 text-end align-middle" style={tableHeaderStyle}>
            Pengambilan
          </th>
          <th className="p-2 text-end align-middle" style={tableHeaderStyle}>
            UOM Pengambilan
          </th>
          <th className="p-2 text-end align-middle" style={tableHeaderStyle}>
            Location
          </th>
          {detail?.draft_status !== 'submit' && (
            <th
              className="p-2 align-middle text-center"
              style={{
                ...tableHeaderStyle,
                width: '15%'
              }}
              hidden={routeValue === 'outbound/history' ? true : false}
            >
              Action
            </th>
          )}
        </tr>
      </thead>
      <tbody>
        {!pickupCommand || pickupCommand.length === 0 ? (
          <tr>
            <td colSpan={9} className="p-2 align-middle text-center">
              Data Empty!
            </td>
          </tr>
        ) : (
          pickupCommand.map((item, i) => {
            return (
              <tr key={i}>
                <td
                  className="p-2 align-middle"
                  style={{
                    backgroundColor: item?.item_alias ? '#FF8F8F' : ''
                  }}
                >
                  {i + 1}
                </td>
                <td
                  className="p-2 align-middle"
                  style={{
                    backgroundColor: item?.item_alias ? '#FF8F8F' : ''
                  }}
                >
                  <div className="mt-3">
                    <OverlayTrigger
                      trigger={['click', 'hover']}
                      placement="bottom"
                      overlay={
                        <Popover id={`popover-positioned-${item?.item_name}`}>
                          <Popover.Body>
                            <div className="text-center">
                              <p className="fw-bold text-uppercase">
                                Item Name
                              </p>
                              <p>{item?.item_name}</p>
                            </div>
                            <hr />
                            <div className="text-center">
                              <p className="fw-bold text-uppercase">
                                Item Code
                              </p>
                              <p>{item?.item_code}</p>
                            </div>
                          </Popover.Body>
                        </Popover>
                      }
                    >
                      <p>
                        {item.item_code && item.item_name
                          ? `${item.item_code} - ${item.item_name}`
                          : item.item_code || item.item_name || '-'}
                      </p>
                    </OverlayTrigger>
                  </div>
                </td>
                <td
                  className="p-2 text-end align-middle"
                  style={{
                    backgroundColor: item?.item_alias ? '#FF8F8F' : ''
                  }}
                >
                  {!item?.item_alias ? '-' : item?.item_alias}
                </td>
                <td
                  className="p-2 text-end align-middle"
                  style={{
                    backgroundColor: item?.item_alias ? '#FF8F8F' : ''
                  }}
                >
                  {!item?.batch ? '-' : item?.batch}
                </td>
                <td
                  className="p-2 text-end align-middle"
                  style={{
                    backgroundColor: item?.item_alias ? '#FF8F8F' : ''
                  }}
                >
                  {item?.expired
                    ? moment(item?.expired, [
                        'DD-MM-YYYY HH:mm:ss',
                        'YYYY-MM-DD HH:mm:ss',
                        'DD-MM-YYYY',
                        'YYYY-MM-DD',
                        moment.ISO_8601
                      ]).format('DD-MM-YYYY')
                    : '-'}
                </td>
                <td
                  className="p-2 text-end align-middle"
                  style={{
                    backgroundColor: item?.item_alias ? '#FF8F8F' : ''
                  }}
                >
                  {!item?.total_pack ? '-' : parseInt(item?.total_pack)}
                  {item.report_pack > 0 && (
                    <span className="text-danger ms-2">
                      ({`-${item?.report_pack}`})
                    </span>
                  )}
                </td>
                <td
                  className="p-2 text-end align-middle"
                  style={{
                    backgroundColor: item?.item_alias ? '#FF8F8F' : ''
                  }}
                >
                  {item?.uom_pack || '-'}
                </td>
                <td
                  className="p-2 text-end align-middle text-primary cursor-pointer"
                  role="button"
                  title={item?.location}
                  style={{
                    backgroundColor: item?.item_alias ? '#FF8F8F' : '',
                    width: '150px'
                  }}
                >
                  <OverlayTrigger
                    trigger={['click', 'hover']}
                    placement="bottom"
                    overlay={
                      <Popover id={`popover-positioned-${item?.item_name}`}>
                        <Popover.Body>
                          <p className="fw-bold">{item?.location}</p>
                        </Popover.Body>
                      </Popover>
                    }
                  >
                    <div style={{ width: '150px' }} className="text-truncate">
                      <Link
                        to={
                          routeValue === 'outbound/history'
                            ? '/outbound/history/detail/location'
                            : '/outbound/sj/detail/location'
                        }
                        state={{
                          slotLocations: detail?.slot_locations,
                          batch: item?.batch,
                          sjCode: detail?.draft_code
                        }}
                        className="text-decoration-none"
                      >
                        {!item?.location ? '-' : item?.location}
                      </Link>
                    </div>
                  </OverlayTrigger>
                </td>
                {detail?.draft_status !== 'submit' && (
                  <td
                    className="p-2 text-end align-middle"
                    style={{
                      backgroundColor: item?.item_alias ? '#FF8F8F' : ''
                    }}
                    hidden={routeValue === 'outbound/history' ? true : false}
                  >
                    <div className="d-flex flex-row gap-2 justify-content-end">
                      <Button
                        className={`btn ${
                          item?.has_wo === true ||
                          detail?.draft_status === 'problem'
                            ? 'btn-secondary opacity-25'
                            : 'btn-primary'
                        } ml-2 ${!item?.item_alias ? 'd-none' : ''}`}
                        disabled={
                          item?.has_wo === true ||
                          detail?.draft_status === 'problem'
                        }
                        size="sm"
                        onClick={() => handleCreateWorkOrder(item)}
                      >
                        + WO
                      </Button>
                      <Button
                        className={`btn ${
                          item?.is_new_command &&
                          detail?.draft_status === 'problem'
                            ? 'btn-danger'
                            : 'btn-secondary opacity-25'
                        } ml-1`}
                        disabled={
                          !item?.is_new_command ||
                          detail?.draft_status !== 'problem'
                        }
                        size="sm"
                        onClick={() =>
                          handleDeleteAddItemPickupCommand(item?.command_id)
                        }
                      >
                        <Trash2 size={13} />
                      </Button>
                      <Button
                        type="button"
                        className={`btn btn-secondary ml-3 ${
                          !item?.is_new_command ||
                          detail?.draft_status !== 'problem'
                            ? 'opacity-25'
                            : ''
                        }`}
                        size="sm"
                        disabled={
                          !item?.is_new_command ||
                          detail?.draft_status !== 'problem'
                        }
                        onClick={() => {
                          setShowModalAddUpdateItem(true)
                          setEditData({
                            type: 'update',
                            command_id: item?.command_id,
                            item_code: item?.item_code,
                            item_alias: item?.item_alias ?? '-',
                            item_batch_id: item?.item_batch_id,
                            total_pack: item?.total_pack,
                            exp_date: item?.expired
                              ? moment(item?.expired, [
                                  'DD-MM-YYYY HH:mm:ss',
                                  'YYYY-MM-DD HH:mm:ss',
                                  'DD-MM-YYYY',
                                  'YYYY-MM-DD',
                                  moment.ISO_8601
                                ]).format('DD-MM-YYYY')
                              : null,
                            qty: item?.qty
                          })
                        }}
                      >
                        <SquarePen size={13} />
                      </Button>
                    </div>
                  </td>
                )}
              </tr>
            )
          })
        )}
      </tbody>
    </Table>
  )
}

export default PickupCommandTable
